var modernizr = window.Modernizr;

exports.isTouch = isTouch;

function isTouch() {
    return modernizr.touchevents;
}
